module.exports = __webpack_public_path__ + "static/sunset-ridge-phase-4-plat-map-c2477821b75e69d3932d818817f3690a.jpg";